export default __webpack_public_path__ + "static/small-field-c7917288ac3ac14a19a0c6fe8bcb9c0d.mp4";